export default __webpack_public_path__ + "img/journal-webfont.82e5557fbeb828e36c67a847160ad4af.svg";